import Create from './Create';
import Update from './Update';
import Delete from './Delete';
import Search from './Search';
import Filter from './Filter';
import Body   from './Body'  ;

type Props = {
  Create: typeof Create;
  Update: typeof Update;
  Delete: typeof Delete;
  Search: typeof Search;
  Filter: typeof Filter;
  Body  : typeof Body;
}

const CityComponents: Props = {
  Create,
  Update,
  Delete,
  Search,
  Filter,
  Body  ,
}

export default CityComponents;
